export const workflowExecutions = ($http: HttpApi) => ({
  get: workflowExecutionId => $http.$get(`/workflow_executions/${workflowExecutionId}`),
});
